import { Attachment as GraphAttachment } from '@microsoft/microsoft-graph-types';

export interface AttachmentItem extends GraphAttachment {}

/**
 * Represents a clickable item that is displayed in the context menu
 * of an attachment list entry
 */
export interface AttachmentMenuItem {
  icon: JSX.Element;
  title: string;
  // Defines what happens, when user clicks on a menu item
  handler: (attachmentItem: AttachmentItem) => void;
}

/**
 * Properties for AttachmentsList component
 */
export interface AttachmentsListProps {
  attachments: AttachmentItem[];
  menu?: AttachmentMenuItem[];
  bgColor?: AttachmentBackgroundColor;
  className?: string;
  attachmentClick?: (attachmentItem: AttachmentItem) => void;
}

/**
 * Background color of single attachment list entry
 */
export enum AttachmentBackgroundColor {
  White,
  Grey,
}
